export enum LoadingState {
  Start = 'start',
  Error = 'error',
  Finish = 'finish',
}
